module.exports = __webpack_public_path__ + "img/RFID手持机.36518458.jpg";